<template>
  <b-row>
    <b-col>
      <h1>Log in</h1>
      <p>
        To sign in or create an account, please select a login partner.
      </p>
      <p>
        Your personal information will be kept private. We will only contact you
        if there is an issue with your account.
      </p>
      <p>
        Unmatched Maker exists because Restoration and Mondo are kind enough to
        allow us to use their Unmatched card designs. Let's return that
        kindness, and be respectful of their intellectual property: please
        <strong>do no publish versions of official decks</strong>. We reserve
        the right to remove any deck, public or private, for any reason, at any
        time. Please try to use your judgement and do not publish decks that are
        offensive or in poor taste.
      </p>
      <p>
        For more information please see our
        <router-link :to="{ name: 'Terms' }">terms</router-link> and our
        <router-link :to="{ name: 'PrivacyPolicy' }">privacy policy</router-link
        >.
      </p>
      <img
        @click="login('google')"
        src="~@/assets/images/login/google_signin_buttons/web/1x/btn_google_signin_dark_normal_web.png"
      />
      <b-button @click="login('discord')">Log in with Discord</b-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "Login",
  components: {},
  metaInfo: {
    title: "Log in"
  },
  data() {
    return {};
  },
  methods: {
    login(service) {
      this.$store.dispatch("login", service);
    }
  }
};
</script>
